import React, {useEffect, useState} from "react";
import {useBreakpointValue,Box,HStack, Center,Heading,Image,VStack, SimpleGrid, Card, Text, Link,CardHeader, CardBody, LinkBox, LinkOverlay} from "@chakra-ui/react";
import code from "../Assets/code.png"
import pmgt from "../Assets/pmgt.png"
import social from "../Assets/social.png"
import IT from "../Assets/IT.png"
import seo from "../Assets/seo.png"
import data from "../Assets/data.png"
import { assets, serviceData } from "../AssetsPort/assets";

import {useSpring ,animated} from "react-spring"
//import { useInView } from "react-spring";
import {useInView} from 'react-intersection-observer'
import {motion} from "motion/react"
import "typeface-ovo"





function Services({toggleProp, setToggle, setSelected}){

let[visible1, setVisible1] = useState(false)
let[visible2, setVisible2] = useState(false)
let[visible3, setVisible3] = useState(false)
let[visible4, setVisible4] = useState(false)
let[visible5, setVisible5] = useState(false)
let[visible6, setVisible6] = useState(false)



let {ref: ref1, inView:inView1} = useInView({triggerOnce: true})
let {ref: ref2, inView: inView2} = useInView({triggerOnce: true})
let {ref :ref3, inView:inView3} = useInView({triggerOnce: true})
let {ref :ref4, inView:inView4} = useInView({triggerOnce: true})
let {ref :ref5, inView:inView5} = useInView({triggerOnce: true})
let {ref :ref6, inView:inView6} = useInView({triggerOnce: true})

let {ref: refServices, inView: inViewServices} = useInView({triggerOnce: false})


let animation1 = useSpring ({
 // to: {opacity: 1, transform: "translateY(0px)"},
  //from: {opacity: 0, transform: "translateY(100px)"},
  opacity: visible1? 1:0,
  transform: visible1? "translateY(0px)": "translateY(100px)",
  config: {tension: 200, friction: 20, duration: 1000}
})


let animation2 = useSpring ({
   opacity: visible2? 1:0,
   transform: visible2? "translateY(0px)": "translateY(100px)",
   config: {tension: 200, friction: 20, duration: 1000}
 })

 
let animation3 = useSpring ({
   opacity: visible3? 1:0,
   transform: visible3? "translateY(0px)": "translateY(100px)",
   config: {tension: 200, friction: 20, duration: 1000}
 })
 
let animation4 = useSpring ({
  opacity: visible4? 1:0,
  transform: visible4? "translateY(0px)": "translateY(100px)",
  config: {tension: 200, friction: 20, duration: 1000}
})

let animation5 = useSpring ({
  opacity: visible5? 1:0,
  transform: visible5? "translateY(0px)": "translateY(100px)",
  config: {tension: 200, friction: 20, duration: 1000}
})

let animation6 = useSpring ({
  opacity: visible6? 1:0,
  transform: visible6? "translateY(0px)": "translateY(100px)",
  config: {tension: 200, friction: 20, duration: 1000}
})


useEffect((e)=>{
 
  if(inView1){
    setVisible1(true)
    }
},[inView1])


useEffect((e)=>{
 
  if(inView2){
    setVisible2(true)
    }
},[inView2])


useEffect((e)=>{
 
  if(inView3){
    setVisible3(true)
    }
},[inView3])


useEffect((e)=>{
 
  if(inView4){
    setVisible4(true)
    }
},[inView4])


useEffect((e)=>{
 
  if(inView5){
    setVisible5(true)
    }
},[inView5])


useEffect((e)=>{
 
  if(inView6){
    setVisible6(true)
    }
},[inView6])


useEffect((e)=>{

  if(inViewServices){
    setSelected("Services")
  }
},[inViewServices])






let mobileView = useBreakpointValue({
  base: true,
  md: false
})


let tabletView = useBreakpointValue({
  md: true, 
  lg: false
})


let nextHub = useBreakpointValue({
  lg:true,
  xl:false
 })

  
  return(
    <div>
      <motion.div viewport={{once:true}}  initial={{opacity:0}} whileInView={{opacity: 1}} transition={{duration: 1}}>
        <VStack maxWidth="full" py={10} px={mobileView?5: 10}  alignItems="left" spacing={8} backgroundColor={toggleProp? "#11001f":"gray.100"} color={toggleProp? "white":"gray.700"} ref={refServices}>
          
        <Center mb={-10}>
        <VStack>
        <motion.h4 initial={{y:-20, opacity:0}} whileInView={{y:0, opacity: 1}} transition={{duration: 0.5, delay:0.3}} className="text-lg font-ovo">What I Offer</motion.h4>
        <div style={{position:"relative"}}>
        <motion.div initial={{y:-20, opacity:0}} whileInView={{y:0, opacity: 1}} transition={{duration: 0.5, delay:0.5}} >
        {/* <Heading as="h2" size="2xl" id="services" ref={refServices}>My Services</Heading> */}
        <h2 id="services" className="font-ovo text-5xl"  style={{position:"relative", zIndex:10}}>My Services</h2>

          <div style={{position:"relative"}}></div>
          <div style={{position:"absolute", top:"0%", right:"-10%", zIndex:0, display:toggleProp? "block":"none", pointerEvents:"none"}}>
          <img src={assets.theme_pattern} className="w-36" />      
          </div>
        </motion.div>
        </div>
        <motion.p initial={{opacity:0}} whileInView={{opacity: 1}} transition={{duration: 0.5, delay:0.7}}  className="text-center font-ovo max-w-2xl mx-auto mt-3 mb-10">
          {/* I am a full-stack developer from California, USA with 10 years experience 
          in multiple companies like Microsoft, Tesla and Apple. */}
          I am a full-stack software developer with a keen interest for detail 
          and a knack for cafting immersive user experiences that drive meaningful engagement.
        </motion.p>

        </VStack>
        </Center>
        
        {/*Automatically fits as many columns as possible: repeat(auto-fit,). Each column is at least 200px wide but can grow to 1fr: minmax(200px, 1fr)*/}
        <motion.div viewport={{once:true}}  initial={{opacity:0}} whileInView={{opacity: 1}} transition={{duration: 0.6, delay: 0.9}}  className="grid grid-cols-[repeat(auto-fit,minmax(200px,1fr))] gap-6 mt-10" >
          {serviceData.map((f, index)=>{
            return <motion.div key={index} whileHover={{scale:1.05}} className={`border border-gray-400 rounded-lg px-8 py-12
            cursor-pointer ${toggleProp? "hover:shadow-[4px_4px_0_#fff]":"hover:shadow-[4px_4px_0_#000]"} ${toggleProp? "hover:bg-[#11002f]":"hover:bg-[#fcf4ff]"} hover:-translate-y-1 duration-500`}>
              <img src={f.icon} alt="" className="w-10" />
              <h3 className={`text-lg my-4 ${toggleProp? "":"text-gray-700"}`} style={{WebkitBackgroundClip:toggleProp&& "text", WebkitTextFillColor:toggleProp&& "transparent", backgroundImage:toggleProp&& "linear-gradient(270deg, #DF8908 50%, #B415FF 100%)"}}>{f.title}</h3>
              <p className={`text-sm ${toggleProp? "text-white/80":"text-gray-600"} leading-5`}>{f.description}</p>
            {/*href={f.link}*/}  <a  className={`flex items-center gap-2 ${toggleProp? "text-white":""} text-sm mt-5`}>
                Read more <img src={assets.right_arrow} alt={f.title} className="w-4" />
              </a>
            </motion.div>
          })}

        </motion.div>


    
        <motion.p initial={{opacity:0}} whileInView={{opacity: 1}} transition={{duration: 0.5, delay:0.7}} className="text-center font-ovo max-w-2xl mx-auto mt-3 ">
        Dive into my service offerings, your pathway to transformative solutions for your digital endeavours. Explore my expertise and discover how I can help you thrive in the digital landscape. 
        With a commitment to excellence and innovation, I provide a range of specialized services designed to empower your digital ventures.
        </motion.p>
   
        {/* <motion.div initial={{y:-20, opacity:0}} whileInView={{y:0, opacity: 1}} transition={{duration: 0.5, delay:0.5}} >
        <Text fontSize="xl" style={{margin: 5, paddingTop: 20}}>Dive into my service offerings, your pathway to transformative solutions for your digital endeavours. Explore my expertise and discover how I can help you thrive in the digital landscape. 
        With a commitment to excellence and innovation, I provide a range of specialized services designed to empower your digital ventures.
        </Text>
        </motion.div> */}
    
      
      
            
            <Box width="full"  >
            
            
            <SimpleGrid columns={{base: 1, md: 2, lg:2}} gap={8}  paddingLeft={mobileView||nextHub? 0:10} paddingRight={mobileView||nextHub? 0:10}  >
            
              <motion.div viewport={{once:true}} initial={{y:100, opacity:0}} whileInView={{y:0, opacity:1}} transition={{delay:0.2, duration: 0.6}}>
              {/*BoxShadow, First one is horizontal and the second is vertical */}

              <Card borderRadius={10} bg={toggleProp && "#18181b"} cursor="pointer" boxShadow= "20px 0px 20px rgba(0,0,0,0.5)" >
              <CardHeader p={8}>
                <Image style={{WebkitFilter: toggleProp && "invert(100%)"}} src={code} loading="lazy" width={24} height={24}/>      
                <Heading mt={5} color={toggleProp && "white"} >Software Development</Heading>
              </CardHeader>
       
              <CardBody p={8} pt={-8} >
              
              <Text  color={toggleProp? "white": "#64748b"} fontSize={["md", "lg"]} >
              I specialize in crafting tailored software solutions to meet your unique business needs.
              Whether you're a startup looking to build your MVP or an established enterprise seeking to streamline operations, I develop
              scalable and robust software applications that drive efficiency and innovation. I create dynamic and responsive web applications using the
              latest technologies. Beyond initial development, i offer ongoing maintenance and support services to ensure your 
              software remains secure and optimized for performance.
              </Text>

              </CardBody>
            </Card>
            </motion.div>
            
            
            {/* <animated.div style={animation2} ref={ref2} > */}
            <motion.div viewport={{once:true}} initial={{y:100, opacity:0}} whileInView={{y:0, opacity:1}} transition={{delay:0.3, duration: 0.6}}>
            <Card borderRadius={10}  bg={toggleProp && "#18181b"}  cursor="pointer"  boxShadow= "20px 0px 20px rgba(0,0,0,0.5)" >
              <CardHeader p={8}>
                <Image  src ={pmgt} loading="lazy"  style={{WebkitFilter: toggleProp && "invert(100%"}} width={24} height={24}/>
                <Heading mt={5} s color={toggleProp && "white"}>Project Management</Heading>
              </CardHeader>
       
              <CardBody p={8} pt={-8} >
              
              <Text color={toggleProp? "white": "#64748b"} fontSize={["md", "lg"]} >
              I specialize in implementing Agile methodologiesto drive efficiency and colloboration in web development projects. By braking down complex
              tasks into manageable iterations and fostering open communication, I ensure projects are delivered on time and within budget.i excel in creating
              comprehensive project plans that outline clear objectives, timelines and resource allocatios. By meticulously managing project schedules and milstones, 
              I ensure timely delivery of high quality delivearables that exceed client expectations.
              </Text>

              </CardBody>
            </Card>
            </motion.div>
            

            
            {/* <animated.div style={animation3} ref={ref3}> */}
            <motion.div viewport={{once:true}} initial={{y:100, opacity:0}} whileInView={{y:0, opacity:1}} transition={{delay:0.4, duration: 0.6}}>
            <Card borderRadius={10} cursor="pointer" bg={toggleProp && "#18181b"}  boxShadow= "20px 0px 20px rgba(0,0,0,0.5)" >
              <CardHeader p={8}>
                <Image  src ={social} loading="lazy"  style={{WebkitFilter: toggleProp && "invert(100%)"}} width={24} height={24}/>
                <Heading mt={5}color={toggleProp && "white"} >Digital Marketing</Heading>
              </CardHeader>
       
              <CardBody p={8} pt={-8} >
              
              <Text size="3xl" color={toggleProp? "white": "#64748b"} fontSize={["md", "lg"]} >
             I develop customized digital marketing strategies tailored to your business goals and target audience. Whether you're looking to increase brand awareness,
             generate leads or drive sales, I leverage data-driven insights to create effective and results-driven marketing plans. I develop engaging social media strategies
             to enhance your brand presence and engage with your audience across popular platforms such as Facebook, Instagram, Twitter, LinkedIn and more. I design and execute 
             targeted email marketing campaigns to nurture leads and foster customer relationships.
              </Text>

              </CardBody>
            </Card>
            </motion.div>
          

            {/* <animated.div style={animation4} ref={ref4}>             */}
            <motion.div viewport={{once:true}} initial={{y:100, opacity:0}} whileInView={{y:0, opacity:1}} transition={{delay:0.5, duration: 0.6}}>
            <Card borderRadius={10} cursor="pointer" bg={toggleProp && "#18181b"} boxShadow= "20px 0px 20px rgba(0,0,0,0.5)" >
              <CardHeader p={8}>
                <Image  src ={IT} loading="lazy" style={{WebkitFilter: toggleProp && "invert(100%"}} width={24} height={24}/>
                <Heading mt={5} color={toggleProp && "white"}>IT Consulting</Heading>
              </CardHeader>
       
              <CardBody p={8} pt={-8} >
              
              <Text size="3xl" color={toggleProp? "white": "#64748b"} fontSize={["md", "lg"]} >
              I specialize in optimizing IT Infrastructure to enhance performance, reliability and security.
              whether you're looking to streamline your network architecture, upgrade hardware and software systems
              or implement robust cybersecurity measures, I provide tailored solutions to meet your specific needs.
              I offer expert cybersecurity consulting services to protect your organization's sensitive data and assets.
              From conducting risk assessments and implementing security protocols to safeguarding your digital infrastructure 
              against evolving threats and deliver tangible results.
              </Text>

              </CardBody>
            </Card>
            </motion.div>

            
            {/* <animated.div style={animation5} ref={ref5}> */}
            <motion.div viewport={{once:true}} initial={{y:100, opacity:0}} whileInView={{y:0, opacity:1}} transition={{delay:0.6, duration: 0.6}}>
            <Card borderRadius={10} cursor="pointer" bg={toggleProp && "#18181b"} boxShadow= "20px 0px 20px rgba(0,0,0,0.5)" >
              <CardHeader p={8}>
                <Image  src={seo} loading="lazy" style={{WebkitFilter: toggleProp && "invert(100%)"}} width={24} height={24}/>
                <Heading mt={5} color={toggleProp && "white"}>SEO Optimization</Heading>
              </CardHeader>
       
              <CardBody p={8} pt={-8} >
              
              <Text size="3xl" color={toggleProp? "white": "#64748b"} fontSize={["md", "lg"]} >
             I ensure that your website is fully optimized to attract organic traffic and enhance user experience. I conduct comprehensive
             technical audits to identify and fix issues that may be hindering your website's performance. I employ best practices to ensure that your
             website meets search engine standards and achieves maximum visibility. I provide in-depth analytics and reporting to track the performance 
             of your SEO efforts and measures the impact on your website's visibility and traffic. I provide actionable insights to help 
             you make informed decisions and continuously improve your SEO strategy, ensuring long term success in the ever-evolving landscape of SEO.             </Text>

              </CardBody>
            </Card>
            </motion.div>

            
            {/* <animated.div style={animation6} ref={ref6}> */}
            <motion.div viewport={{once:true}} initial={{y:100, opacity:0}} whileInView={{y:0, opacity:1}} transition={{delay:0.7, duration: 0.6}}>

            <Card borderRadius={10} cursor="pointer" bg={toggleProp && "#18181b"} boxShadow= "20px 0px 20px rgba(0,0,0,0.5)" >
              <CardHeader p={8}>
                <Image  src={data} loading="lazy" style={{WebkitFilter: toggleProp && "invert(100%"}} width={24} height={24}/>
                <Heading mt={5} color={toggleProp && "white"}>Data Analysis</Heading>
              </CardHeader>
       
              <CardBody p={8} pt={-8} >
              
              <Text size="3xl" color={toggleProp? "white": "#64748b"} fontSize={["md", "lg"]} >
              Transforming raw data into actionable insights, I specialize in creating visually compelling charts, graphs
              and dashboards that help you understand your data at a glance. From simple trend analyses to complex interactive 
              visualizations, I leverage powerful tools and techniques to unlock the story hidden within your data. I provide 
              expert guidance and consultation to help you define and execute a comprehensive data strategy that aligns with your 
              business objectives. From data acquisition and storage to analysis and visualization, I work with you to develop a
              roadmap for leveraging data as a strategic asset that drives decision making and propels your business towards success.
              </Text>

              </CardBody>
            </Card>
            </motion.div>
            

         
        

            </SimpleGrid>
          

           
             

      
             </Box>




        </VStack> 
      </motion.div>   
    </div>
  )
}



export default Services;
